import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useNoReservePriceBadgeExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.NoReservePriceBadge,
        AmplitudeVariants.NoReservePriceBadge.Treatment
    );
